import { IntlShape } from "react-intl";
import * as yup from "yup";
import { GetTranslation } from "../../../../translations/GetTranslation";

export const getSchema = (intl: IntlShape) =>
  yup
    .object()
    .shape({
      firstName: yup.string().required(),
      lastName: yup.string().required(),
      gender: yup.string().required(),
      birthdate: yup.date().required(),
      ahvNumber: yup
        .string()
        .matches(/^(\d{3}).(\d{4}).(\d{4}).(\d{2})$/, GetTranslation(intl, "person.validation.ahvNumberNotValid"))
        .required(),
      emailAddress: yup.string().email().required(),
      phoneNumber: yup.string().matches(/([+]{1})(\d|\s)+$/, { excludeEmptyString: true }),
      mobileNumber: yup.string().matches(/([+]{1})(\d|\s)+$/, { excludeEmptyString: true }),
      ciceroNumber: yup.string().matches(/^\d{5,}$/, { excludeEmptyString: true }),
      homeCountry: yup.string().required(),
      placeOfOrigin: yup.string().when("nationalityIsSwiss", {
        is: true,
        then: yup.string().required(),
      }),
      employerInformation: yup.string().required(),
      street: yup.string().required(),
      streetNumber: yup.string().required(),
      zipCode: yup.string().required().when("country",
        {
          is: "Deutschland" || "Frankreich" || "Italien",
          then: yup.string().matches(/^(\d){5}$/),
        }
      ).when("country",
        {
          is: "Schweiz" || "Österreich" || "Liechtenstein",
          then: yup.string().matches(/^(\d){4}$/),
        }
      ),
      city: yup.string().required(),
      country: yup.string().required(),
      correspondenceLanguage: yup.string().required(),
      employer: yup.string().when("preferredContact", {
        is: "business",
        then: yup.string().required(),
      }),
      employerStreet: yup.string().when("preferredContact", {
        is: "business",
        then: yup.string().required(),
      }),
      employerStreetNumber: yup.string().when("preferredContact", {
        is: "business",
        then: yup.string().required(),
      }),
      employerZipCode: yup.string().when("preferredContact", {
        is: "business",
        then: yup.string().required().when("employerCountry",
          {
            is: "Deutschland" || "Frankreich" || "Italien",
            then: yup.string().matches(/^(\d){5}$/),
          }
        ).when("country",
          {
            is: "Schweiz" || "Österreich" || "Liechtenstein",
            then: yup.string().matches(/^(\d){4}$/),
          }
        ),
      }),
      employerCity: yup.string().when("preferredContact", {
        is: "business",
        then: yup.string().required(),
      }),
      employerCountry: yup.string().when("preferredContact", {
        is: "business",
        then: yup.string().required(),
      }),
    })
    .defined();
